import React from 'react';
import PropTypes from 'prop-types';
import {
  FDHeadlineText,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';

const PageHeadline = ({ value }) => {
  const isMobile = useMobileLayout();
  return <FDHeadlineText value={value} size={isMobile ? 'sm' : 'md'} />;
};

PageHeadline.defaultProps = {
};

PageHeadline.propTypes = {
  value: PropTypes.string.isRequired,
};

export default PageHeadline;
